import { Dtos } from "@inrev/common";
import { type DateTime } from "luxon";
import { type TagColor } from "../../primitives/Tag";

type ProConImportance = Dtos.Decisioning.ProConImportance;
type DataNeededImportance = Dtos.Decisioning.DataNeededImportance;

export const PRO_CON_IMPORTANCE_LABELS: Record<ProConImportance, string> = {
	1: "General",
	2: "Material",
	3: "Key",
	4: "Override",
};

export const DATA_NEEDED_IMPORTANCE_LABELS: Record<DataNeededImportance, string> = {
	1: "Desired",
	2: "Needed",
	3: "Crucial",
};

export const PRO_CON_IMPORTANCES: readonly ProConImportance[] = [1, 2, 3, 4];
export const DATA_NEEDED_IMPORTANCES: readonly DataNeededImportance[] = [1, 2, 3];

export const toOptions = <T extends string>(values: readonly T[]) =>
	values.map((value) => ({ value, label: value }));

export const CLOSE_REASON_OPTIONS = toOptions(
	Dtos.Decisioning.dataNeededClosedReasonSchema.options,
);

export const DATA_NEEDED_IMPORTANCE_TAG_COLORS: Record<DataNeededImportance, TagColor> = {
	1: "gray",
	2: "yellow",
	3: "red",
};

export const IMPORTANCE_DOT_CLASSES: Record<DataNeededImportance, string> = {
	1: "bg-intent-neutral-text",
	2: "bg-intent-warning-text",
	3: "bg-danger",
};

export const DECISION_STAGE_TAG_COLORS: Record<Dtos.Decisioning.DecisionStage, TagColor> = {
	initial_submission_follow_up: "blue",
	post_submission_follow_up: "yellow",
	approve: "green",
	decline: "red",
	close: "gray",
};

export const formatDecisioningDate = (date: DateTime) => date.toLocal().toFormat("M/d/yy");

export const DECISION_STAGE_LABELS: Record<Dtos.Decisioning.DecisionStage, string> = {
	initial_submission_follow_up: "Initial submission follow-up",
	post_submission_follow_up: "Post-submission follow-up",
	approve: "Approve",
	decline: "Decline",
	close: "Close",
};

export const DECISION_STAGE_OPTIONS = Dtos.Decisioning.decisionStageSchema.options.map((value) => ({
	value,
	label: DECISION_STAGE_LABELS[value],
}));

export const DATA_NEEDED_STATUS_LABELS: Record<Dtos.Decisioning.DataNeededStatus, string> = {
	open: "Open",
	received: "Received",
	closed: "Closed",
};
